module.exports = __webpack_public_path__ + "va.svg?e486a73486de2ab83e854608429809d2";